import type { DataApiInputParams } from 'src/types/api';

import type { Builder } from './utils';
import { appendFormData, getHeaders, getQueryString } from './utils';

export default (builder: Builder) => {
  return {
    getExistingMeetings: builder.query({
      async queryFn(arg: DataApiInputParams, _, extraOptions, fetchWithBQ) {
        const url = `mini-experts/meetings?${getQueryString(arg.params)}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    }),
    createMeeting: builder.mutation({
      async queryFn(args: { params: any }, _, extraOptions, baseQuery) {
        const formData = appendFormData(args.params);

        const result: any = await baseQuery({
          url: `mini-experts/meetings`,
          method: 'POST',
          body: formData,
          ...getHeaders(`mini-experts/meetings`, formData)
        });
        if (result.error) {
          return result;
        }
        return { data: result ?? { msg: 'Meeting created successfully' } };
      }
    }),
    updateMeeting: builder.mutation({
      async queryFn(
        args: { meetingId: number; params: any },
        _,
        extraOptions,
        baseQuery
      ) {
        const formData = appendFormData(args.params);

        const result: any = await baseQuery({
          url: `mini-experts/meetings`,
          method: 'PATCH',
          body: formData,
          ...getHeaders(`mini-experts/meetings`, formData)
        });
        if (result.error) {
          return result;
        }
        return { data: result ?? { msg: 'Meeting updated successfully' } };
      }
    }),
    deleteMeeting: builder.mutation({
      async queryFn(
        args: { params: { id: number } },
        _,
        extraOptions,
        baseQuery
      ) {
        const formData = appendFormData(args.params);

        const result: any = await baseQuery({
          url: `mini-experts/meetings`,
          method: 'DELETE',
          body: formData,
          ...getHeaders(`mini-experts/meetings`, formData)
        });
        if (result.error) {
          return result;
        }
        return { data: result ?? { msg: 'Meeting deleted successfully' } };
      }
    }),

    getSmartMeetAccessRights: builder.query({
      async queryFn(arg: DataApiInputParams, _, extraOptions, fetchWithBQ) {
        const url = `mini-experts/smart-meet-perms-details?${getQueryString(
          arg.params
        )}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    }),
    updateSmartMeetResource: builder.mutation({
      async queryFn({ params }, { getState }, extraOptions, baseQuery) {
        const formData = appendFormData(params);
        return baseQuery({
          url: `mini-experts/smart-meet-perms-details`,
          method: 'POST',
          body: formData,
          ...getHeaders(`mini-experts/smart-meet-perms-details`, formData)
        });
      }
    })
  };
};
